import tawuniyaDrive from "assets/svg/tawuniyaDrivePrimary.svg";
import roadSide from "assets/svg/roadSidePrimary.svg";
import ithra from "assets/svg/ithraPrimary.svg";
import motorInspect from "assets/svg/motorInspectPrimary.svg";
import freeCarMaintainence from "assets/svg/freeCarMaintainence.svg";
import endtoendClaim from "assets/svg/endtoendClaim.svg";

export const MotorServicesData = [
	{
		serviceTitle: "Our Exclusive and Added-Value Services",
		textCenter: true,
		serviceSubtitle:
			"In addition to benefits provided by the policy, Tawuniya also provides a number of exclusive and added value services that help you get the motor care you deserve",
		Services: [
			{
				id: 1,
				pillName: "MOTOR",
				Search: true,
				serviceCardData: [
					{
						headingEl: "Tawuniya drive",
						discrptionEl:
							"It mesures your driving behavior and rewards you weekly,",
						iconE1: `${tawuniyaDrive}`,
					},
					{
						headingEl: "Roadside assistance",
						discrptionEl: "Our services can be trustable, honest and worthy",
						iconE1: `${roadSide}`,
					},
					{
						headingEl: "Motor vehicle periodic inspection",
						discrptionEl:
							"Transporting the vehicle to the periodic inspection  station.",
						iconE1: `${motorInspect}`,
					},


					{
						headingEl: "Ithra Prime",
						discrptionEl:
							"Special discounts on a wide range of services and products supplied by our partners.",
						iconE1: `${ithra}`,
					},
				],
			},
		],
	},
];

export const travelServicesData = [
	{
		serviceTitle: "Our Exclusive and Added-Value Services",
		textCenter: true,
		serviceSubtitle:
			"In addition to benefits provided by the policy, Tawuniya also provides a number of exclusive and added value services that help you get the motor care you deserve",
		Services: [
			{
				id: 1,
				pillName: "MOTOR",
				Search: true,
				serviceCardData: [
					{
						headingEl: "Tawuniya drive",
						discrptionEl:
							"It mesures your driving behavior and rewards you weekly,",
						iconE1: `${tawuniyaDrive}`,
					},
					{
						headingEl: "Roadside assistance",
						discrptionEl: "Our services can be trustable, honest and worthy",
						iconE1: `${roadSide}`,
					},
					{
						headingEl: "Motor vehicle periodic inspection",
						discrptionEl:
							"Transporting the vehicle to the periodic inspection  station.",
						iconE1: `${motorInspect}`,
					},


					{
						headingEl: "Ithra’a",
						discrptionEl:
							"Special discounts on a wide range of services and products that are supplied by distinguished partners and famous brands in various sectors",
						iconE1: `${ithra}`,
					},
					{
						headingEl: "Tawuniya drive",
						discrptionEl:
							"It mesures your driving behavior and rewards you weekly,",
						iconE1: `${tawuniyaDrive}`,
					},
					{
						headingEl: "Roadside assistance",
						discrptionEl: "Our services can be trustable, honest and worthy",
						iconE1: `${roadSide}`,
					},
					{
						headingEl: "Motor vehicle periodic inspection",
						discrptionEl:
							"Transporting the vehicle to the periodic inspection  station.",
						iconE1: `${motorInspect}`,
					},


					{
						headingEl: "Ithra’a",
						discrptionEl:
							"Special discounts on a wide range of services and products that are supplied by distinguished partners and famous brands in various sectors",
						iconE1: `${ithra}`,
					},
				],
			},
		],
	},
];
